import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../../../../providers/AuthProvider";
import AuthService from "../../../../../../services/authService";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { logout } from "../../../../../../redux/slices/auth";

function ProfilePopper({ open, anchorEl }) {
  const { setAuthUpdate } = useAuth();
  const dispatch = useDispatch();
  const history = useHistory();
  const handleLogout = async () => {
    await AuthService.logout();
    dispatch(logout());
    setAuthUpdate(true);
  };
  return (
    <Popper
      data-group="popper-element"
      open={open}
      anchorEl={anchorEl}
      placement={"bottom-end"}
      sx={{
        zIndex: 1500,
      }}
    >
      <Box>
        <Paper
          elevation={1}
          sx={{
            borderRadius: "10px",
          }}
        >
          <List>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  history.push("/profile");
                }}
                sx={{
                  py: "0px",
                }}
              >
                <ListItemText primary="Profile" />
              </ListItemButton>
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  py: "0px",
                }}
                onClick={handleLogout}
              >
                <ListItemText primary="Logout" />
              </ListItemButton>
            </ListItem>
          </List>
        </Paper>
      </Box>
    </Popper>
  );
}

ProfilePopper.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.any,
};

export default ProfilePopper;
